import * as UI from '@brewlogix/blx-ui'

import { BrewOption, FoodOption, PatronOption, SeatingOption } from 'src/types/schema/graphql'

import React from 'react'
import { parseEnumLabel } from 'src/util/helpers'

interface IAmenitiesPill {
    item: PatronOption | FoodOption | SeatingOption | BrewOption
}

const AmenitiesPill: React.FC<IAmenitiesPill> = ({ item }) => {
    const getIconSlug: (value: string) => string = (a: string) => {
        return a === 'WiFi_Available' ? 'HeroIcons.Wifi' : a.replace(/_/g, '')
    }
    return (
        <UI.Pill
            theme='default'
            shape='full'
            label={parseEnumLabel(item)}
            size='md'
            customClasses='border-0 -ml-3 flex flex-row-reverse'
        >
            <UI.Icon size='md' slug={`${getIconSlug(item.toString())}`} customClasses='mr-2' />
        </UI.Pill>
    )
}
export default AmenitiesPill
